export abstract class GeneralErrorService {
    abstract informUser(error: any): any;
}
